import { render, staticRenderFns } from "./ChatBot.vue?vue&type=template&id=57d36c99&"
import script from "./ChatBot.vue?vue&type=script&lang=js&"
export * from "./ChatBot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports